import axios from 'axios'
import store from '@/store'
import { Notification } from 'element-ui'
import { getToken } from '@/utils/auth'
import { isInTelegramWebApp } from '@/utils/telegram';
// 如果正在重新导向，就不需要再跳太多弹框
var redirecting = false;
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 120000
})

service.interceptors.request.use(config => {
  if (store.getters.token)
    config.headers['Authorization'] = getToken()
  return config
}, error => {
  Notification.error(error.response.data.message)
  Promise.reject(error)
})

service.interceptors.response.use(res => {
  // 如果在 mini app，错误直接往下 pass
  if (isInTelegramWebApp() && res.data.code !== 401) {
  // if (true && res.data.code !== 401) {
    return res.data
  }
  if (res.data.code !== 200) {
    // Start handle Blob data
    if (res.data.type === 'application/json') {
      const reader = new FileReader()
      reader.readAsText(res.data);
      reader.onload = function () {
        Notification.error(JSON.parse(reader.result).message)
      }
      return;
    }
    // 下载 blob 档案（统一直接下载）
    if (res.data.type === 'application/force-download') {
      const blob = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);
      const aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = url;
      if (res.headers['content-disposition']) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(res.headers['content-disposition']);
        aLink.download = matches[1];
      }
      document.body.appendChild(aLink);
      aLink.click();
      return;
    }
    // End handle Blob data

    Notification.error(res.data.message)

    if (res.data.code === 401) {
      if (!redirecting) {
        redirecting = true;
        Notification.error('你已被登出，请重新登录')
        store.dispatch('LogOut').then(() => {
          setTimeout(() => {
            location.reload()
          }, 2000)
        })
        return
      }
    }
    return Promise.reject(res.data.message)
  }
  return res.data
}, error => {

  if (error.response.data && error.response.data.code === 401) {
    if (!redirecting) {
      redirecting = true;
      Notification.error('登录超时，请重新登录')
      store.dispatch('LogOut').then(() => {
        setTimeout(() => {
          location.reload()
        }, 2000)
      })
      return
    }
    // 排除红点泡泡接口在重启或无网路时出现「服务器忙碌中，请稍后再试」的通知
  } else if (error.response.data.path === '/Unallocated/all') {
    return
  } else if (error.response.data.status && error.response.data.status === 400) {
    Notification.error('参数有误，请确认查询条件')
    return
  } else {
    Notification.error('服务器忙碌中，请稍后再试')
    // ✅ 判断是否在 Telegram Mini App 中
    if (isInTelegramWebApp()) {
      store.dispatch('LogOut').then(() => { })
    }
    return Promise.reject(error)
  }

})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js